// src/services/api.ts
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
  withCredentials: true,
});

/* ============================
   REQUEST INTERCEPTOR
============================ */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Request setup failure
    return Promise.reject(error);
  }
);

/* ============================
   RESPONSE INTERCEPTOR (NEW)
============================ */
api.interceptors.response.use(
  (response) => response,

  (error) => {
    // Network / server down
    if (!error.response) {
      console.error("API unreachable:", error);

      return Promise.reject({
        message: "Network error. Please check your connection.",
        status: 0,
      });
    }

    const { status } = error.response;

    // Token expired / Unauthorized
    if (status === 401) {
      console.warn("Unauthorized – logging out");

      localStorage.removeItem("access_token");

      // Force redirect safely
      window.location.href = "/login";

      return Promise.reject(error);
    }

    // Forbidden
    if (status === 403) {
      console.warn("Access forbidden");
    }

    // Server errors
    if (status >= 500) {
      console.error("Server error:", error.response);
    }

    return Promise.reject(error);
  }
);

export default api;
